import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Segment, Icon, Menu, Button, Popup } from "semantic-ui-react";

import MenuVentas from "./menuSuperior/MenuVentas";
import MenuExtraescolares from "./menuSuperior/MenuExtraescolares";
import MenuEscuelas from "./menuSuperior/MenuEscuelas";

import { loginOps } from "../../ducks/login";

class MenuSuperior extends React.Component {
  state = { userButtonOvered: false };

  handleLogoutClick = () => this.props.logout();

  handleNotificacionesClick = () => console.log("Notificaciones");

  handleGoToHome = () => this.props.history.push("/");

  onMouseUserButton = () =>
    this.setState(state => ({ userButtonOvered: !state.userButtonOvered }));

  render() {
    return (
      <React.Fragment>
        <Menu borderless fixed="top">
          <Menu.Item>
            <h3>ExtraGestor</h3>
          </Menu.Item>
          <Popup
            content="Ir al Inicio"
            trigger={
              <Menu.Item onClick={this.handleGoToHome}>
                <Icon name="home" size="big" color="pink" />
              </Menu.Item>
            }
          />
          <MenuVentas />
          <MenuExtraescolares />
          <MenuEscuelas />
          <Menu.Menu position="right">
            <Popup
              content="Notificaciones"
              trigger={
                <Menu.Item onClick={this.handleNotificacionesClick} fitted>
                  <Icon color="pink" name="bell outline" size="big" />
                </Menu.Item>
              }
            />
            <Popup
              content="Cerrar Sesión"
              trigger={
                <Menu.Item>
                  <Button
                    content={
                      (this.props.user && this.props.user.displayName) ||
                      this.props.user.email.split("@")[0]
                    }
                    color="pink"
                    icon="user"
                    name="logout"
                    inverted={!this.state.userButtonOvered}
                    onClick={this.handleLogoutClick}
                    onMouseEnter={this.onMouseUserButton}
                    onMouseLeave={this.onMouseUserButton}
                  />
                </Menu.Item>
              }
            />
          </Menu.Menu>
        </Menu>
        <Segment basic padded="very">
          {this.props.children}
        </Segment>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.session.user
});

const actions = {
  logout: loginOps.userLogOut
};

export default connect(
  mapStateToProps,
  actions
)(withRouter(MenuSuperior));



// WEBPACK FOOTER //
// ./src/pages/appLayout/MenuSuperior.jsx